import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main id="page-content-layer">
        <div className="policy-page">
          <div className="policy-container">
            <h1>Delivery Information</h1>
            <p className="policy-intro">
              Below are the common delivery methods, estimated timeframes, and
              shipping fees. Please refer to the checkout page and carrier
              updates for the most accurate information. Timeframes may be
              longer during sales and holidays.
            </p>

            <section className="policy-section">
              <h2>Methods & Estimated Time</h2>
              <div className="policy-table-wrapper">
                <table className="policy-table">
                  <thead>
                    <tr>
                      <th>Method</th>
                      <th>Cost</th>
                      <th>ETA</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Store Pickup</td>
                      <td>Free</td>
                      <td>~ 3–7 business days</td>
                      <td>
                        Pickup notification sent when ready; limited holding
                        time
                      </td>
                    </tr>
                    <tr>
                      <td>Standard Delivery</td>
                      <td>As shown at checkout (free over threshold)</td>
                      <td>~ 2–7 business days</td>
                      <td>Varies by region</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="policy-section">
              <h2>Notes</h2>
              <ul>
                <li>
                  Tracking will be provided after dispatch; an order may ship in
                  multiple parcels.
                </li>
                <li>
                  During peak seasons and holidays, processing and transit times
                  may be longer.
                </li>
                <li>
                  Remote or special regions may be excluded or require
                  additional time.
                </li>
              </ul>
            </section>

            <div className="policy-actions">
              <Link onClick={toTop} className="link-underline" to="/">
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default Delivery;
